import { createContext } from 'react';

const LargeMobileContext = createContext(false);

export default LargeMobileContext;
